<template>
    <header class="ds-main-header">
        <div class="ds-main-header-inner ds-app-shell">
            <div class="ds-main-header-logo">
                <Logo />
            </div>
            <nav class="ds-main-header-nav" aria-label="Разделы">
                <Menu />
            </nav>
            <div>
                <Options />
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import Menu from './Menu.vue'
import Options from './Options.vue'
</script>
